/**
 * Logo BonUrba — version horizontale (icône + texte).
 * Utilise l'image SVG officielle servie depuis /public.
 */
export default function BonUrbaLogo({ height = 32, className = '' }) {
  return (
    <img
      src="/BonUrba_noir_horizontal.svg"
      alt="BonUrba"
      height={height}
      className={className}
      style={{ height, width: 'auto' }}
    />
  )
}
